import React from 'react';

const LoadingSpinner = () => (
  <>
    <h5>Loading...</h5>
  </>
);

export default LoadingSpinner;
